// extracted by mini-css-extract-plugin
module.exports = {"text":"_1yI6QzaEv_PiGFA36gaWlV"};